import { apiServerRoutes } from "../constants/apiRoutes";
import {
  deleteAPICallServer,
  getAPICallServer,
  postAPICallServer,
  putAPICallServer,
} from "../utils/axios.util";

class AddressService {
  async addAddress(req: any) {
    return postAPICallServer(apiServerRoutes.ADD_ADDRESS, req.body, req);
  }
  async getAddress(req: any) {
    return getAPICallServer(apiServerRoutes.FETCH_ADDRESS, req);
  }
  async editAddress(req: any) {
    return putAPICallServer(
      `${apiServerRoutes.ADD_ADDRESS}/${req?.params?.id}`,
      req.body,
      req
    );
  }
  async deleteAddress(req: any) {
    return deleteAPICallServer(
      `${apiServerRoutes.ADD_ADDRESS}/${req?.params?.id}`,
      req
    );
  }
  async makeDefaultAddress(req: any) {
    return putAPICallServer(
      `${apiServerRoutes.DEFAULT_ADDRESS}/${req?.params?.id}`,
      req
    );
  }
}

export default new AddressService();
